// Rendering dates that came from the API.
//
// Rails serializes a `date` column as a bare "YYYY-MM-DD", and `new Date()` parses
// the date-only form as UTC MIDNIGHT (per spec), so toLocaleDateString then shifts
// it into the viewer's zone and shows the PREVIOUS day for anyone west of UTC.
// Every US user is west of UTC, so "valid until 2027-07-26" rendered as
// "7/25/2027" for essentially the whole user base.
//
// A calendar date has no time and no zone - it means the same day everywhere - so
// it must be formatted without any conversion. A timestamp (created_at, paid_at)
// is a real instant and SHOULD be localized; use formatInstant for those.

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

// Formats a calendar date with no timezone shift. Accepts the bare "YYYY-MM-DD"
// Rails sends; anything else falls back to normal parsing so a timestamp passed
// here by mistake still renders something sane.
export function formatDate(value, options) {
  if (!value) return null;
  const text = String(value);
  if (DATE_ONLY.test(text)) {
    const [y, m, d] = text.split('-').map(Number);
    // Constructed in local time, so the calendar date survives formatting intact.
    return new Date(y, m - 1, d).toLocaleDateString(undefined, options);
  }
  return new Date(text).toLocaleDateString(undefined, options);
}

// For real instants (created_at / paid_at), where converting to the viewer's
// zone is the correct behaviour.
export function formatInstant(value, options) {
  if (!value) return null;
  return new Date(value).toLocaleDateString(undefined, options);
}
